import script from "./VideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoModal.vue?vue&type=script&setup=true&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=0611b69e&scope=true&lang=css"

const __exports__ = script;

export default __exports__